// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { valueFromMeters } from 'helpers/unitConversion'

const getAdditionalAntennas = (antennas, unitType) => (
  antennas.reduce((a, d, i) => {
    // we don't want to include the main antenna in this set.
    if (i === 0) {
      return a
    }

    const {
      antennaCode,
      modelNumber,
      segmentEndAntennaId,
    } = d

    const centerline = valueFromMeters(d.centerline, unitType) + (unitType === 'SI' ? ' m' : ' ft')

    a.push({
      antennaCode,
      centerline,
      modelNumber,
      segmentEndAntennaId,
    })

    return a
  }, [])
)

export default getAdditionalAntennas
